import fetcher from '../fetcher';

export interface OrgNode {
	id: number;
	username: string;
	fullName: string;
	code: string;
	email: string;
	division: string;
	reportToId: number | null;
	children: OrgNode[];
	groupCode?: string;
	groupName?: string;
	divisionName?: string;
	divisionCode?: string;
}

export const getOrgStructure = () => {
	return fetcher<OrgNode[]>({
		api: '/admin/organization-structure',
		method: 'POST',
		body: {}, // Empty object as per requirement: "No body (or empty object if forced by client)"
	});
};

export const orgStructureKeys = {
	all: ['org-structure'] as const,
};
